import script from "./ViewDelegationLogPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewDelegationLogPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewDelegationLogPage.vue?vue&type=style&index=0&id=198d05fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-198d05fd"]])

export default __exports__